import React, { useState, useEffect } from "react";
import { Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import { IoClose, IoMenu } from "react-icons/io5";

import HoAccounts from "./HoAccounts";
import HoExpences from "./HoExpences";

const HoAccountDashbord = () => {
  const [selectedLabel, setSelectedLabel] = useState("HoAccounts");
  const location = useLocation();
  const [isSidebarVisible, setSidebarVisible] = useState(true);

  // Define the button routes here
  const AccountsUserButton = [
    { label: "Expenses", path: "HoAccounts" },
    { label: "Ho Expenses", path: "HoExpences" },
    
    // You can add more button entries here
  ];

  useEffect(() => {
    // Extract last segment from location path
    const currentPathSegment = location.pathname.split("/").pop();
    const currentButton = AccountsUserButton.find(
      (button) => button.path === currentPathSegment
    );
    if (currentButton) {
      setSelectedLabel(currentButton.label);
    }
  }, [location.pathname]);

  const handleButtonClick = () => setSidebarVisible(false);
  const toggleSidebar = () => setSidebarVisible(!isSidebarVisible);

  return (
    <>
      {/* Navbar */}
      <nav className="navbar shadow-sm p-3 bg-body rounded navbar-light bg-light d-flex align-items-center justify-content-between position-relative">
  <span className="navbar-brand mb-0 h1">
    <i>Ho</i> Accounts User
  </span>

  <div className="position-absolute top-50 start-50 translate-middle text-center">
    <h5 className="mb-0">{selectedLabel}</h5>
    <h6 className="text-muted">
      {JSON.parse(localStorage.getItem("SelectedOutlet") || "{}")?.Outlate_Name}
    </h6>
  </div>

  {isSidebarVisible ? (
    <IoClose className="sidebar-toggle-icon" onClick={toggleSidebar} />
  ) : (
    <IoMenu className="sidebar-toggle-icon" onClick={toggleSidebar} />
  )}
</nav>


      {/* Sidebar & Main Content */}
      <div className="d-flex">
        {/* Sidebar */}
        <div className={`sidebar ${isSidebarVisible ? "open" : ""}`}>
          <div className="button-container mt-2">
            {AccountsUserButton.map((button, index) => (
              <Link
                key={index}
                to={`/HoAccDashbord/${button.path}`}
                className="btn btn-primary mb-2 MasterCreationButtons"
                onClick={handleButtonClick}
              >
                {button.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-3">
          <Routes>
            <Route path="/" element={<Navigate to="/HoAccDashbord/HoAccounts" replace />} />
            <Route path="/HoAccounts" element={<HoAccounts />} />
            <Route path="/HoExpences" element={<HoExpences />} />
            {/* Add more Route components here */}
          </Routes>
        </div>
      </div>
    </>
  );
};

export default HoAccountDashbord;
